<template>
  <body class="authentication-bg">

        <div class="account-pages mt-5 mb-5">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-8 col-lg-6 col-xl-5">
                        <div class="text-center">
                            <a href="#" class="logo">
                                <img src="" alt="" height="22" class="logo-light mx-auto">
                            </a>
                            <p class="text-muted mt-2 mb-4">Vehicle Licence </p>
                        </div>
                        <div class="card">

                            <div class="card-body p-4">
                                
                                <div class="text-center mb-4">
                                    <h4 class="text-uppercase mt-0">Reset PAssword</h4>
                                </div>

                                <form action="#">

                                    <div class="form-group mb-3">
                                        <label for="emailaddress">Email address</label>
                                        <input class="form-control" type="email" id="emailaddress" required="" placeholder="Enter your email" v-model="email">
                                    </div>

                                    <div class="form-group mb-0 text-center">
                                    
                                        <button class="btn btn-primary btn-block" type="submit" v-on:click='login'>Reset PAssword</button>
                                    </div>

                                </form>

                            </div> <!-- end card-body -->
                        </div>
                        <!-- end card -->

                        <div class="row mt-3">
                            <div class="col-12 text-center">
                                <p> <a href="" class="text-muted ml-1"><i class="fa fa-lock mr-1"></i>Back to Login?</a></p>
                            </div> <!-- end col -->
                        </div>
                        <!-- end row -->

                    </div> <!-- end col -->
                </div>
                <!-- end row -->
            </div>
            <!-- end container -->
        </div>
        <!-- end page -->
  </body>
</template>

<script>
// @ is an alias to /src

///////// IMPORT COOKIE SERVICE
    import  cookieOps from "@/services/cookieOps.js";
/////////////////////////
    import router from '@/router/index'

export default {
    
  name: 'passReset',
data(){
return {
      email:'',
      password:''
    };},

  /// SCOPE METHODS
  methods:{
alertDisplay() {
        // $swal function calls SweetAlert into the application with the specified configuration.
        this.$swal('Heading', 'this is a Heading', 'OK');
      },

      ///// LOGIN FOR APPMART ADMIN
 login(){
     try{
this.axios.post('http://105.112.130.227:5029/api/auth/loginadmin', {
                        email: this.email,
                        password: this.password,
                    }).then((response) => {
                        console.log(response);
// set cookies
cookieOps.setCookie('app_init',response.data.token);
router.push('dashboard')

})
 //this.alertDisplay();
     }catch(e){
         console.log(e)
     }
},

}
}


</script>
<style scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:400, 500, 700);
@import url(https://fonts.googleapis.com/css?family=Karla:400, 700);
template {
    position: relative;
    min-height: 100%;
}
body {
    padding-bottom: 60px;
    overflow-x: hidden;
}
.authentication-bg.enlarged {
    min-height: 100px;
}
body.authentication-bg {
    background-image: url(../../assets/bg-light-img.jpg);
    background-size: cover;
    background-position: center;
}
</style>